import InfoFinancial from "../components/info-financial/InfoFinancial";
export default function InfoFinancialPage() {
  return (
    <>
      <InfoFinancial></InfoFinancial>
    </>
  );
}
